import { AddressI, AddressType } from "../../pojo/AddressI";
import type { Nullable } from "../../pojo/Util";
import { S25ObjectUtil } from "./s25.object.util";

export namespace S25Address {
    export function extract(addrJson: Nullable<AddressI>, addrType: AddressType) {
        const addr: any = S25ObjectUtil.propertyGetParentWithChildValue(addrJson, "address_type", addrType);
        const lines: string[] = addr?.street_address?.toString().split(", ");
        const line1: string | undefined = lines?.[0];
        const line2: string | undefined = lines?.length > 1 ? lines.splice(1).join(", ") : undefined;
        return {
            line1: line1 || "",
            line2: line2 || "",
            city: addr?.city || "",
            state: addr?.state_prov || "",
            zip: addr?.zip_post || "",
            country: addr?.country || "",
            phone: addr?.phone || "",
            fax: addr?.fax || "",
        };
    }

    export function toNode(addrObj: AddressI, addrType: AddressType): AddressI {
        const addrNode: AddressI = {
            street_address: addrObj.street || "",
            country: addrObj.country || "",
            address_type: addrType,
            city: addrObj.city || "",
            zip_post: addrObj.zip || "",
            phone: addrObj.phone || "",
            state_prov: addrObj.state || "",
            fax: addrObj.fax || "",
        };

        if ([AddressType.Work, AddressType.Home].indexOf(addrType) > -1) {
            addrNode.email = addrObj.email || "";
        }

        return addrNode;
    }
}
